import { Box, IconButton, Wrap } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { Fragment, memo, useCallback } from "react";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../../../../../components/CenteredContent";
import { Icon } from "../../../../../../components/Icon";
import { MenuItem } from "./MenuItem";

export const TOP_BAR_HEIGHT = "36px";

export const TopBar = memo(
  /**
   * @typedef {Object} Props
   * @property {import("react").Dispatch<import("react").SetStateAction<boolean>>} setIsSearchOpened
   */
  /**
   * @param {Props} props
   */
  function TopBar({ setIsSearchOpened }) {
    const intl = useIntl();

    const { menu } = useConfigurationMenu({ alias: "header-top-bar" });

    const handleClickSearch = useCallback(() => {
      setIsSearchOpened((prev) => !prev);
    }, [setIsSearchOpened]);

    return (
      <Box backgroundColor="brandPrimary.200" px="1rem">
        <CenteredContent>
          <Wrap
            spacing="1rem"
            justify="flex-end"
            alignItems="center"
            py="0.375rem">
            {menu?.items.map((menuItem, index) => (
              <Fragment key={index}>
                <MenuItem menuItem={menuItem} key={index} />

                <Box w="1px" alignSelf="stretch" backgroundColor="gray.400" />
              </Fragment>
            ))}

            <IconButton
              onClick={handleClickSearch}
              variant="ghost"
              size="xs"
              icon={
                <Icon icon="ms_search" size="1.5rem" color="brandPrimary.700" />
              }
              aria-label={intl.formatMessage({ defaultMessage: "Rechercher" })}
            />
          </Wrap>
        </CenteredContent>
      </Box>
    );
  },
);
